export default __webpack_public_path__ + "static/media/Mujeres_Empresarias.898a89fb.svg";